export default __webpack_public_path__ + "static/flowerpendantfront-7a4affdc6375b33b986ed061f73bdf32.png";